import React, { Component } from 'react';
import { Field, reduxForm, reset } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import FormField from '../form-field';
import Alert from '../../components/alert';
import { formatMessage } from '../../lib/intl';

const FORM_NAME = 'signupForm';

const i18n = defineMessages({
  emailNotPresent: {
    id: 'passwordResetForm.errors.emailNotPresent',
    defaultMessage: 'Enter an email',
  },
  emailFieldLabel: {
    id: 'passwordResetForm.fields.email.label',
    defaultMessage: 'Email',
  },
});

class PasswordResetForm extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
    this.onLoginClick = this.onLoginClick.bind(this);
    this.onSendAgainClick = this.onSendAgainClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(props) {
    return this.props.onSubmit(props);
  }

  onLoginClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.props.onLoginClick();
  }

  onSendAgainClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.props.onSendAgainClick();
  }

  renderAlert() {
    if (!this.props.error) return null;

    return (
      <Alert type="warning" className="alert-form-top">
        <i className="fa fa-fw fa-ban" />
        {this.props.error}
      </Alert>
    );
  }

  render() {
    const { handleSubmit } = this.props;

    if (this.props.clearForm) {
      this.props.dispatch(reset(FORM_NAME));
      this.props.onClearForm();
    }

    return (
      <div>
        {this.renderAlert()}
        <div className="modal-title modal-section text-center divider">
          <h1>
            <FormattedMessage
              id="passwordResetForm.pageTitle"
              defaultMessage="Password reset"
            />
          </h1>
          <p className="text-muted">
            <FormattedMessage
              id="passwordResetForm.instructions"
              defaultMessage="Enter the email you used to create your Key Travel account,
            and we will send you a special link to update your password"
            />
          </p>
        </div>

        <div className="modal-section">
          <form onSubmit={handleSubmit(this.onSubmit)}>
            <Field
              name="email"
              type="email"
              component={FormField}
              label={this.formatMessage(i18n.emailFieldLabel)}
            />

            <button type="submit" className="btn btn-primary full-width">
              <FormattedMessage
                id="passwordResetForm.passwordResetLink"
                defaultMessage="Send password reset link"
              />
            </button>
          </form>
        </div>
        <p className="text-muted">
          <FormattedMessage
            id="passwordResetForm.rememberedPassword.neverMind"
            defaultMessage="Never mind,"
          />
          {' '}
          <a href="/login" onClick={this.onLoginClick}>
            <FormattedMessage
              id="passwordResetForm.rememberedPassword.remember"
              defaultMessage="I remember it"
            />
          </a>
        </p>
      </div>
    );
  }
}

PasswordResetForm.defaultProps = {
  onSubmit: () => {},
  onLoginClick: () => {},
  onSendAgainClick: () => {},
};

const validate = (values, props) => {
  const { intl: { formatMessage} } = props;
  const errors = {};

  if (!values.email) {
    errors.email = formatMessage(i18n.emailNotPresent);
  }

  return errors;
};

export default injectIntl(reduxForm({ form: FORM_NAME, validate })(PasswordResetForm));



// WEBPACK FOOTER //
// ./src/desktop/components/password-reset/form.js